<template>
    <div class="page-wrapper member-wrap">
        <div class="container-fluid">
            <breadcrumb :items="breadcrumbItems" />
            <div class="page-title">
                <h1>View Term Request</h1>
                <button class="clear-search" @click="clearData">Clear Search</button>
            </div>

            <term-request-search :filters="filterQuery" :clear="clear" @onSearch="filterData" />

            <div class="row member-card member-card-list">
                <div class="clientsData-wrap" ref="memberListing">
                    <div class="top-pagination">
                        <pagination :rows.sync="rows" :filters="filterQuery" />
                    </div>
                    <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th v-for="column in columns" :key="column.key" :width="column.width">
                                    {{column.label}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="loading">
                                <tr>
                                    <td colspan="9" align="center">Loading...</td>
                                </tr>  
                            </template>
                            <template v-else>
                            <template v-if="rows && rows.records && rows.records.length < 1">
                                <tr>
                                    <td colspan="9" align="center">No records found.</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="row in rows.records" :key="row.termId">
                                <td>
                                        {{issetItem(row.policyId)}}
                                </td>
                                <td>
                                    <template v-if="row.userInfo && Object.keys(row.userInfo).length">
                                    {{issetItem(row.userInfo?.fullname)}}<br/>
                                    {{issetItem(row.userInfo?.email)}}<br/>
                                    {{issetItem(row.userInfo?.phone1)}}<br/>
                                    </template>
                                    <template v-else>
                                        <span>N/A</span>
                                    </template>
                                </td>
                                <td>
                                   <template v-if="row.agentInfo && Object.keys(row.agentInfo).length">
                                    {{ issetItem(row.agentInfo?.fullname) }}<br/>
                                    {{ issetItem(row.agentInfo?.email) }}<br/>
                                    {{ issetItem(row.agentInfo?.phone1) }}<br/>
                                </template>
                                <template v-else>
                                    <span>N/A</span>
                                </template>

                                </td>
                                <td>
                                    <strong>Request Sent date : </strong> {{issetItem(row.requestDate)}}
                                    <br/>
                                    <strong>Effective Date :</strong>
                                    <span v-if="row.policy">{{issetItem(row.policy.effective_date)}}</span>
                                    <br/>
                                    <strong>Requested Termination date :</strong>
                                    {{issetItem(row.termDate)}}
                                </td>
                                <td>
                                    <template v-if="row.pId == 'ALL'">
                                        <template v-if="row.plans && row.plans.length > 0">
                                        <span v-for="(p, index)  in row.plans" :key="index">
                                            {{issetItem(p?.plan_name_system)}}
                                        </span>
                                        </template>
                                        <template v-else>
                                            <span>N/A</span>
                                        </template>
                                        
                                    </template>
                                    <template v-else>
                                        <p> {{  issetItem(row.plan?.plan_name_system)}}</p>
                                    </template>
                                </td>
                                <td>
                                    <strong>{{issetItem(row.termed_by)}}</strong>
                                    <template v-if="row.termed_by === 'Agent' && row.requested_rep">
                                        <br/>
                                        {{issetItem(row.requested_rep)}}
                                    </template>
                                </td>
                                <td>
                                    {{issetItem(row.termReason)}}
                                </td>
                                <td>                                
                                    <div 
                                    :class="{
                                        'alert alert-success': row.termStatus === 'A',
                                        'alert alert-danger': row.termStatus === 'R',
                                        'alert alert-warning': row.termStatus !== 'A' && row.termStatus !== 'R'
                                    }" 
                                    role="alert"
                                    >
                                    {{ getStatusText(row.termStatus) }}
                                    </div>
                                </td>

                                <td>
                                    <div class="signature-image" @click="openSignature(row.signatureUrl)" v-if="verifySignature(row.signatureUrl)">
                                            <img :src='row.signatureUrl' style="width: 50px; height: 50px;" >
                                    </div>
                                    <div class="signature-image" v-else>
                                        <span>N/A</span>
                                    </div>
                                </td>
                            </tr>
                            </template>
                            </template>
                        </tbody>
                    </table>
                     </div>
                    <pagination :rows.sync="rows" :filters="filterQuery" />
                </div>
            </div>
        </div>
        <signature-modal
             ref="signatureModal"
            v-model="showSignatureDialog"
            :is-open="showSignatureDialog"
            :signature-url="selectedSignatureUrl"
            @close="closeSignatureDialog"
        />
    </div>
</template>
<script>
// import Api from "@/resource/Api";
import { apiUrl } from '@/resource/EndPoints/endpoints'
import axios from "axios";
import TermRequestSearch from "@/views/TermRequest/partials/TermRequestSearch.vue";
import SignatureModal from "@/views/TermRequest/partials/SignatureModal.vue";

const filterData = {
    policy_id: "",
    member_name: "",
    plan_name: "",
    agent_name: "",
    term_status: "",
};

export default {
    name: "ViewTermRequest",
    components: {
        TermRequestSearch,
         SignatureModal    
    },
    data() {
        return {
            filterQuery: {...filterData},
            columns: [
                { key: "policyId", label: "System ID", width: "100px" },
                { key: "userInfo", label: "Member Info", width: "200px" },
                { key: "agentInfo", label: "Rep Info", width: "200px" },
                { key: "requestDate", label: "Dates", width: "280px" },
                { key: "planName", label: "Plan", width: "200px" },
                { key: "termed_by", label: "Requested By", width: "200px" },
                { key: "termReason", label: "Term Reason", width: "200px" },
                {key:"termStatus", label:"Term Status",width:"50px"},
                { key: "signatureUrl", label: "Signature", width: "50px" },
            ],
            clear: false,
            breadcrumbItems: [{ title: "View Term Request", active: true }],
            showSignatureDialog: false,
            selectedSignatureUrl: '',
            rows:[],
            loading: false
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        clearData() {
            console.log("clearing filter")
            console.log("filterData",filterData)
            console.log("filterQuery",this.filterQuery)
            this.clear = !this.clear;
            this.filterQuery = {...filterData}
            this.getData(this.filterQuery);
        },
        filterData(filters) {
            this.filterQuery = {...filters};
            this.getData(this.filterQuery);
        },
        async getData(filters = {}) {
            let loader = this.$loading.show();
            this.loading = true;
            try {
                let path = "v2/get-term-requests";
                const response = await axios.get(apiUrl+path, { params: filters });
                this.rows = response.data;
            } catch (error) {
                console.error('Error fetching term requests:', error);
                this.$toast.error('Failed to fetch term requests');
            } finally {
                loader.hide();
                this.loading = false;
            }
        },
        issetItem(item) {
            console.log("Checking",item)
            return item !== null || item !== undefined || item !== '' || item !== [] || item !='[]' || item != 'undefined'  || item != 'null' 
            || item != ""
            ? item : 'N/A';
        },
        openSignature(url) {
            this.selectedSignatureUrl = url;
            this.showSignatureDialog = true;
            this.$nextTick(() => {
                this.$refs.signatureModal.show();
            });
        },
        closeSignatureDialog() {
            this.showSignatureDialog = false;
            this.selectedSignatureUrl = '';
        },
        getStatusText(status) {
            return status === 'A' ? 'Approved' : status === 'R' ? 'Rejected' : 'Pending Review';
        },
        verifySignature(imgUrl) {

            const regex = /\.png/;
            return (regex.test(imgUrl)) === true ? true : false
        
        }

    },
};
</script>
<style src="@/assets/css/viewclients.css"></style>